'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _user = require('../../redux/modules/user');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FormattedMessage = require('../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _analytics = require('../../redux/modules/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        email: (0, _user.getBidderEmail)(state),
        fullName: (0, _user.getUserFullName)(state),
        fullStorySessionUrl: (0, _analytics.getFullStorySessionUrl)(state)
    };
};

var DeskPopup = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(DeskPopup, _PureComponent);

    function DeskPopup() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DeskPopup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeskPopup.__proto__ || (0, _getPrototypeOf2.default)(DeskPopup)).call.apply(_ref, [this].concat(args))), _this), _this.formLinkClick = function () {
            var _this$props = _this.props,
                email = _this$props.email,
                fullName = _this$props.fullName,
                fullStorySessionUrl = _this$props.fullStorySessionUrl,
                liveBidding = _this$props.liveBidding,
                useLink = _this$props.useLink;


            var fields = [];

            fullName && fields.push('interaction[name]=' + encodeURIComponent(fullName));
            email && fields.push('interaction[email]=' + email);

            if (liveBidding) {
                fields.push('email[subject]=' + encodeURIComponent('Live Bidding Feedback'));
                fields.push('ticket[labels_new]=' + encodeURIComponent('Live Bidding Feedback,Qualaroo Feedback'));
            } else {
                fields.push('email[subject]=' + encodeURIComponent('Website Feedback'));
                fields.push('ticket[labels_new]=' + encodeURIComponent('Qualaroo Feedback'));
            }

            fullStorySessionUrl && fields.push('ticket[custom_fullstory]=' + encodeURIComponent(fullStorySessionUrl));

            var url = 'https://liveauctioneers.desk.com/customer/widget/emails/new' + (fields.length ? '?' + fields.join('&') : '');

            document.getElementsByTagName('body')[0].classList.add('body-modal-open');

            var form = document.getElementById('desk-form');
            var overlay = document.getElementById('desk-form-overlay');
            var container = document.getElementById('desk-form-container');
            var linkContainer = document.getElementById('desk-form-link-container');

            if (form) {
                form.src = url;
            }
            if (overlay) {
                overlay.style.display = 'block';
            }
            if (container) {
                container.style.display = 'block';
            }

            if (!useLink && linkContainer) {
                linkContainer.style.display = 'none';
            }
            return false;
        }, _this.formCloseClick = function () {
            var useLink = _this.props.useLink;

            document.getElementsByTagName('body')[0].classList.remove('body-modal-open');

            var form = document.getElementById('desk-form');
            var overlay = document.getElementById('desk-form-overlay');
            var container = document.getElementById('desk-form-container');
            var linkContainer = document.getElementById('desk-form-link-container');

            form.src = '';
            if (overlay) {
                overlay.style.display = 'none';
            }
            if (container) {
                container.style.display = 'none';
            }

            if (!useLink && linkContainer) {
                linkContainer.style.display = 'block';
            }

            return false;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DeskPopup, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                showWidget = _props.showWidget,
                textId = _props.textId,
                useLink = _props.useLink;


            var deskWidget = useLink ? (0, _jsx3.default)('a', {
                onClick: this.formLinkClick,
                href: '#'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: textId
            })) : (0, _jsx3.default)('div', {
                className: 'form-link-container',
                id: 'desk-form-link-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-link',
                href: '#',
                onClick: this.formLinkClick
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'deskpopup.feedback'
            })));
            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: 'form-overlay',
                id: 'desk-form-overlay'
            }), (0, _jsx3.default)('div', {
                className: 'form-container',
                id: 'desk-form-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-close',
                href: '#',
                onClick: this.formCloseClick
            }, void 0, '\xD7'), (0, _jsx3.default)('iframe', {
                className: 'form',
                frameBorder: '0',
                id: 'desk-form'
            })), showWidget && deskWidget);
        }
    }]);
    return DeskPopup;
}(_react.PureComponent), _class.defaultProps = {
    email: '',
    fullName: '',
    fullStorySessionUrl: '',
    liveBidding: false
}, _class.defaultProps = {
    showWidget: true
}, _temp2);
exports.default = (0, _reactRedux.connect)(mapStateToProps)(DeskPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeskPopup/DeskPopup.js
// module id = lHUE
// module chunks = 60